/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { lazyRoute } from './lazyRoute';
import { type NavigationRoute } from './navigationRoute';

export const accountActionsRoutes: NavigationRoute[] = [
    {
        path: '/sign-up',
        lazy: lazyRoute(() => import('../../src/containers/SignUpPage')),
    },
    {
        path: '/log-in',
        lazy: lazyRoute(() => import('../../src/containers/LogInPage')),
    },
    {
        path: '/mfa',
        lazy: lazyRoute(() => import('../../src/containers/LogInPage')),
    },
    {
        path: '/magic-log-in',
        lazy: lazyRoute(
            () => import('../../src/containers/MagicLogInPage/MagicLogInPage')
        ),
    },
    // CSR New Session Logic - newUrl is optional and may not be passed
    {
        path: '/csr-log-in/:csrToken/:newUrl?',
        lazy: lazyRoute(() => import('../../src/containers/CsrLogInPage')),
    },
    {
        path: '/reset-password',
        lazy: lazyRoute(() => import('../../src/containers/ResetPasswordPage')),
    },
    // Password Reset Logic
    {
        path: '/reset-account/:resetToken?',
        lazy: lazyRoute(() => import('../../src/containers/ResetAccountPage')),
    },
];
